// src/encounter/recording-header-control.tsx
//
// Frame v2 · the ambient recording control in the encounter PAGE header (round 18r design, frame `encounter-visit`,
// zone Z4): the mic button, then — while recording — "Recording · mm:ss" with Stop. It only draws: the state and the
// Start / Stop calls are the ambient panel's own (`AmbientScribePanel` `onRecordingControl`), the same handlers the
// panel's "Record encounter" card called, recording-consent gate included. Nothing here logs.
import { Icon } from '@scripsteam/scrips-signal-ds';
import type { AmbientRecordingControl } from './ambient/AmbientScribePanel';
import { recordingControlAtRest } from './ambient/recording-control-at-rest';
import { H } from './intelligence/rail-classes';
import { RECORDING_WORDS, clockOf } from './intelligence/rail-words';

export function RecordingHeaderControl({ control }: { control: AmbientRecordingControl }) {
  const live = control.status === 'recording' || control.starting;
  return (
    <span data-slot="recording-header-control" className={H.group}>
      <button
        type="button"
        data-slot="recording-mic"
        className={H.mic}
        aria-label={RECORDING_WORDS.mic}
        title={RECORDING_WORDS.mic}
        // Start only at rest (idle, or a finished recording the panel offers to record again), and only when the consent gate
        // allows it (the panel leaves `start` out otherwise).
        disabled={live || !recordingControlAtRest(control) || !control.start}
        onClick={() => control.start?.()}
      >
        <Icon name="mic" size={16} aria-hidden />
      </button>
      {live ? (
        <span data-slot="recording-pill" className={H.pill}>
          <span className={H.dot} aria-hidden />
          <span role="status" className={H.pillText}>
            {control.starting && control.status !== 'recording' ? RECORDING_WORDS.starting : `${RECORDING_WORDS.recording} · ${clockOf(control.elapsed)}`}
          </span>
          <button type="button" className={H.stop} onClick={control.stop}>
            {RECORDING_WORDS.stop}
          </button>
        </span>
      ) : null}
    </span>
  );
}
